module.exports = __webpack_public_path__ + "img/client-2.b5c856fd.jpg";